import axios from 'axios';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';





// Create the Axios instance
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  
    withCredentials: true,
  //testing
  headers: {
    'Content-Type': 'application/json',
    'Accept-Language': 'fa', 


  },
});



api.interceptors.request.use(
  async (config) => {
      const init_token = localStorage.getItem("access_token_chart");

    config.headers['Authorization'] =  `Bearer ${init_token}`; 
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor for handling errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      console.error('API Error:', error.response.data);

      if (error.response.status === 401) {
        if (typeof window !== 'undefined') {
         // window.location.href = 'https://tablokhani.com/';
        }
      }

      if (error.response.status === 404) {
        throw { status: 404, message: "Resource not found", details: error.response.data };
      }
      if (error.response.status === 400) {
        try {
        
          toast.error(error.response.data.error);
        } catch (e) {
          console.error('Error parsing validation message:', e);
        }
      }
      if (error.response.status === 422) {
      
        try {
          toast.error(Object.entries(error.response.data.errors)[0][1][0]);
        } catch (e) {
          console.error('Error parsing validation message:', e);
        }
      }

      if (error.response.status === 403) {
        alert('You do not have permission to perform this action.');
      }
    } else if (error.request) {
      console.error('No response received:', error.request);
    } else {
      console.error('Request setup error:', error.message);
    }

    return Promise.reject(error);
  }
);

export default api;
